<lcs-loading-overlay
  class="flex-dir-col"
  [show]="callState | lcsCallState : 'loading'"
  *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'Mailbox'"
>
  <div class="detail-page-headerbar">
    <div class="left">
      <div class="page-heading">
        <h2 class="page-title">
          {{ mailbox?.extension.number }} - {{ mailbox?.extension.name }}
        </h2>
      </div>
    </div>

    <div class="right context-actions">
      <button
        type="button"
        mat-button
        [matMenuTriggerFor]="updateDetailsMenu"
        matTooltip="Info"
        aria-label="Mailbox Info"
        id="mailbox-detail-info"
      >
        <mat-icon>info</mat-icon>
      </button>

      @if (isSystemUser && (canClearMailbox() || canResetMailbox())) {
        <button
          type="button"
          mat-button
          [matMenuTriggerFor]="mailboxMenu"
          aria-label="Mailbox Actions"
          matTooltip="More Actions"
          id="mailbox-detail-more-actions"
        >
          <mat-icon>more_horiz</mat-icon>
        </button>
      }
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <ndt-two-column-layout>
      <div ndtLeftColumn>
        <ndt-mailbox-detail-left-column
          [mailbox]="mailbox"
          (editMailboxPinClick)="onEditMailboxPinClick($event)"
          [extensionType]="mailbox?.extension?.extensionType.name"
        ></ndt-mailbox-detail-left-column>
      </div>

      <div ndtRightColumn>
        <div class="detail-right-column">
          <ng-container formGroupName="mailbox">
            @if (mailbox) {
              <ndt-mailbox-detail
                [mailbox]="mailbox"
                [extensionPrivileges]="_extensionPrivileges"
                [promptPrivileges]="_promptPrivileges"
                [extensionType]="mailbox?.extension?.extensionType.name"
                [accountId]="mailbox.extension.account.accountId"
                [AccountOperatorExtension]="
                  mailbox.extension.account.operatorExtension?.number +
                  ' - ' +
                  mailbox.extension.account.operatorExtension?.name
                "
                (addNewPromptClick)="onAddNewVoiceMailGreetingPromptClick($event)"
                (editMailboxPinClick)="onEditMailboxPinClick($event)"
              ></ndt-mailbox-detail>
            }
          </ng-container>
        </div>
      </div>
    </ndt-two-column-layout>

    <ndt-form-footer
      (cancel)="onCancel()"
      [visible]="form.dirty"
      [callState]="callState"
    ></ndt-form-footer>
  </form>
</lcs-loading-overlay>

<mat-menu #mailboxMenu="matMenu">
  @if (mailbox) {
    <button
      mat-menu-item
      type="button"
      (click)="onEditMailboxPinClick()"
    >
      Change PIN
    </button>
  }

  @if (isSystemUser && canClearMailbox()) {
    <button
      mat-menu-item
      type="button"
      (click)="clearMailbox()"
    >
      Clear Mailbox
    </button>
  }

  @if (isSystemUser && canResetMailbox()) {
    <button
      mat-menu-item
      type="button"
      (click)="resetMailbox()"
    >
      Reset Mailbox
    </button>
  }
</mat-menu>

<mat-menu #updateDetailsMenu="matMenu">
  <update-details
    [createUser]="mailbox?.createUser"
    [createDate]="mailbox?.createDate"
    [updateUser]="mailbox?.updateUser"
    [updateDate]="mailbox?.updateDate"
  ></update-details>
</mat-menu>